import React, { useEffect, useState } from 'react';
import { OrgDiagram } from 'basicprimitivesreact';
import { PageFitMode } from 'basicprimitives';
import { apiCall } from '../../API/RestApi';
import { Button, Row, Select, Space, Spin, Typography, message } from 'antd';
import { useSelector } from 'react-redux';
import { MinusOutlined, PlusOutlined, RedoOutlined } from '@ant-design/icons';

const { Title } = Typography;

const defaultPhoto = "https://ui-avatars.com/api/?background=random&name=User";

function OrganizationStructure() {
  const token = useSelector((state) => state.user.token);
  const [loading, setLoading] = useState(false);
  const [divisionOptions, setDivisionOptions] = useState([]);
  const [config, setConfig] = useState({
    pageFitMode: PageFitMode.AutoSize,
    autoSizeMinimum: { width: 100, height: 100 },
    cursorItem: 0,
    highlightItem: 0,
    scale: 1,
    templates: [
      {
        name: "customTemplate",
        itemSize: { width: 220, height: 120 },
        minimizedItemSize: { width: 8, height: 8 },
        highlightPadding: { left: 2, top: 2, right: 2, bottom: 2 }
      }
    ],
    defaultTemplateName: "customTemplate",
    items: []
  });

  useEffect(() => {
    fetchData("GET", '/division?nopage=true', 'division');
  }, []);

  const fetchData = (method, url, type) => {
    setLoading(true);
    apiCall({
      method: method,
      url: url,
      data: {
        headers: {
          Authorization: 'Bearer ' + token
        }
      }
    }).then((res) => {
      if (res.status === "success") {
        if (type === 'division') {
          const options = res.data.data.map((d) => ({
            value: d.division_id,
            label: d.name
          }));
          setDivisionOptions(options);
        } else if (type === 'users') {
          const maxNameLength = 22;
          const rows = res.data.data.map((item) => ({
            id: item.users_id,
            parent: item.users_parent_id,
            title: item.name.length > maxNameLength ? item.name.slice(0, maxNameLength) + "..." : item.name,
            description: item.position?.name || '',
            image: item.image ? item.image : defaultPhoto
          }));
          setConfig((prev) => ({
            ...prev,
            items: rows
          }));
        }
      } else {
        message.error("Failed to load data");
      }
      setLoading(false);
    }).catch((err) => {
      console.error(err);
      message.error("An error occurred");
      setLoading(false);
    });
  };

  const handleDivisionSelect = (val) => {
    // Backend IndexUser memakai query param `divisionId`, bukan `division`.
    fetchData("GET", `/users?nopage=true&divisionId=${val}`, 'users');
  };

  const changeZoom = (delta) => {
    setConfig((prev) => ({
      ...prev,
      scale: Math.min(2, Math.max(0.5, Number(((prev.scale || 1) + delta).toFixed(2))))
    }));
  };

  const resetZoom = () => setConfig((prev) => ({ ...prev, scale: 1 }));

  return (
    <div style={{ padding: 24 }}>
      <Title level={3}>Organization Structure</Title>
      <Row style={{ marginBottom: 20, gap: 12, alignItems: 'center' }}>
        <Select
          showSearch
          style={{ width: 300 }}
          placeholder="Select Division"
          options={divisionOptions}
          optionFilterProp="label"
          filterOption={(input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
          }
          onSelect={handleDivisionSelect}
        />
        <Space>
          <Button icon={<MinusOutlined />} onClick={() => changeZoom(-0.1)}>Zoom Out</Button>
          <Button icon={<RedoOutlined />} onClick={resetZoom}>100%</Button>
          <Button icon={<PlusOutlined />} onClick={() => changeZoom(0.1)}>Zoom In</Button>
        </Space>
      </Row>

      {loading ? (
        <div style={{ textAlign: 'center', padding: 40 }}>
          <Spin size="large" />
        </div>
      ) : (
        <Spin spinning={loading}>
          <div style={{ marginTop: 32, textAlign: 'center', border: '1px solid #f0f0f0', borderRadius: 8, padding: 24 }}>
            <OrgDiagram centerOnCursor={true} config={config}  />
          </div>
        </Spin>
      )}
    </div>
  );
}

export default OrganizationStructure;
